import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryState } from 'editor/src/store/gallery/types';

const setPdfSplitUnplacedPagesReducer = (
  state: GalleryState,
  action: PayloadAction<{ uploaderId: string; pdfPages: number[] }>,
) => {
  const split = state.pdfSplits?.find(({ uploaderId }) => uploaderId === action.payload.uploaderId);
  if (split) {
    split.unplacedPdfPages = action.payload.pdfPages;
  }
};

export default setPdfSplitUnplacedPagesReducer;
